import { EActionChat } from 'types';
import { create } from 'zustand';

type State = {
  actionChatStep?: EActionChat;
  stateReview?: { channelId?: string };
};

type Actions = {
  setActionChatStep: (value?: EActionChat) => void;
  setStateReview: (value?: { channelId?: string }) => void;
};

const useChatStore = create<State & Actions>((set) => ({
  actionChatStep: undefined,
  stateReview: undefined,
  setActionChatStep: (value?: EActionChat) =>
    set(() => ({ actionChatStep: value })),
  setStateReview: (value?: { channelId?: string }) =>
    set(() => ({
      stateReview: value,
    })),
}));

export default useChatStore;
